<template>
  <transition name="scroll">
    <div id="page-sales-index">
      <header>
        <div>
          <span>合計</span>
          <div class="sales-amount">
            <em>{{ totalAmount.toLocaleString() }}</em>円
          </div>
          <div class="sales-number">全{{ totalNumber.toLocaleString() }}件</div>
        </div>
        <nav class="level is-mobile">
          <span class="level-item icon" @click="previous">
            <i class="c-icon cachalog-prev" :class="{enable: navPrevious, disable: !navPrevious}">
              <span class="path1"></span><span class="path2"></span><span class="path3"></span>
            </i>
          </span>
          <span>{{ navMin.toLocaleString() }}-{{ navMax.toLocaleString() }}件</span>
          <span class="level-item icon" @click="next">
            <i class="c-icon cachalog-next" :class="{enable: navNext, disable: !navNext}">
              <span class="path1"></span><span class="path2"></span><span class="path3"></span>
            </i>
          </span>
        </nav>
        <button class="button is-rounded is-c-primary is-cs-4 is-large" style="margin: 0 auto; display: block;"
          @click="downloadCSV">CSVダウンロード</button>
      </header>
      <div class="sales-histories">
        <div class="level is-mobile" v-for="(history, i) in currentList" :key="i">
          <div class="is-cs-5">
            <span>{{ datestr(history.created.toDate(), 'Y/m/d H:i') }}</span>
            <span>担当：{{ users[history.users_ref.id] ? users[history.users_ref.id].nickname : '' }}</span>
          </div>
          <span><em class="is-cs-0">{{ history.total.price.value.toLocaleString() }}</em>円</span>
          <router-link :to="{name: 'page-sales', params: {pageId: pageId, saleId: history.id}}">
            <button class="button is-cs-4 has-text-weight-bold">内訳</button>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vuex from 'vuex'
import { db, mixin, datestr, indexOf } from './common.js'
export default {
  mixins: [mixin],
  props: ['pageId'],
  data: () => ({
    totalAmount: 0,
    totalNumber: 0,
    current: 0,
    npp: 25// number per page
  }),
  computed: {
    ...Vuex.mapState({
      user: 'user',
      page: 'page',
      sales: 'sales',
      users: 'users'
    }),
    pageTitle () {
      return this.page.title || ''
    },
    histories () {
      if (!this.sales[this.pageId]) {
        return []
      }
      const histories = Object.keys(this.sales[this.pageId].histories).map(
        key => this.sales[this.pageId].histories[key]
      )
      return histories.sort((a, b) => {
        return (a.created.seconds + '.' + a.created.nanoseconds) < (b.created.seconds + '.' + b.created.nanoseconds) ? 1 : -1
      }) || {}
    },
    maxPage () {
      return Math.floor(this.totalNumber / this.npp)
    },
    navMin () {
      return this.current * this.npp + 1
    },
    navMax () {
      return Math.min(this.totalNumber, (this.current + 1) * this.npp)
    },
    navNext () {
      return this.current < this.maxPage
    },
    navPrevious () {
      return this.current
    },
    currentList () {
      return this.histories.filter((history, i) => {
        return this.navMin <= i + 1 && this.navMax > i
      })
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'page-sales-index') {
        this.current = to.query.p - 1 || 0
      }
    },
    histories (value) {
      let uids = value.map(history => {
        return history.users_ref.id
      })
      uids = new Set(uids)
      uids.forEach(uid => {
        if (!this.users[uid]) {
          this.$store.dispatch('fetchUser', uid)
        }
      })
    }
  },
  methods: {
    downloadCSV () {
      db.collection('pages/' + this.pageId + '/sales').get()
        .then(querySnapshot => {
          console.log(querySnapshot.docs.length)
          const data = {}
          querySnapshot.docs.forEach(doc => {
            if (doc.id === 'total') return false
            doc.data().items.forEach(item => {
              const master = this.page.items[indexOf(this.page.items, 'id', item.id)] || {name: '削除された商品'}
              data[item.id] = data[item.id] || [item.id, master.name, 0, 0]
              data[item.id][2] += item.quantity
              data[item.id][3] += item.price.value * item.quantity
            })
          })
          let csv = Object.entries(data).map(([key, value]) => value)
          csv = csv.reduce((a, b) => {
            return a + b.join(',') + '\n'
          }, '商品ID,商品名,販売数量,販売金額\n')
          const a = document.createElement('a')
          a.href = 'data:text/plain,' + encodeURIComponent(csv)
          a.download = this.page.title + '-sales.csv'
          a.click()
        })
        .catch(error => console.error(error))
    },
    datestr (date, format) {
      return datestr(date, format)
    },
    previous () {
      this.current = Math.max(0, this.current - 1)
      this.$router.push({
        name: 'page-sales-index',
        query: {p: this.current + 1}
      })
    },
    next () {
      this.current = Math.min(this.maxPage, this.current + 1)
      this.$router.push({
        name: 'page-sales-index',
        query: {p: this.current + 1}
      })
      if (!this.histories[Math.min(this.navMax, this.totalNumber) - 1]) {
        this.$store.dispatch('fetchSalesList', [this.pageId, this.npp])
      }
    }
  },
  created () {
    this.$store.commit('changePageMainComponent', 'page-sales')
    this.$store.commit('initializeSales', this.pageId)
    const ref = db.doc('pages/' + this.pageId + '/sales/total')
    if (this.$route.query.p) {
      this.$router.replace({name: 'page-sales-index'})
    }
    this.$store.commit('enqueueAsync')
    ref.get()
      .then(doc => {
        if (doc.exists) {
          this.totalAmount = doc.data().amount
          this.totalNumber = doc.data().counter
          this.$store.dispatch('fetchSalesList', [this.pageId, this.npp, new Date()])
        }
      })
      .catch(() => this.$router.replace({name: 'page'}))
      .finally(() => this.$store.commit('dequeueAsync'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-sales.vue